import {
  background,
  calc,
  useDisclosure,
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  VStack,
  Select,
  Image,
  Text,
  Icon,
} from "@chakra-ui/react";
import { Card, Space, Spin, Table } from "antd";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Line, RiEditLine, RiSearch2Line } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { SET_MASTER_MARKETING } from "../../store/marketing/marketingActionTypes";
import { useMarketingMaster } from "../../store/marketing/reducer";
import MarketingMasterEditDrawer from "../drawer/MarketingMasterEditDrawer";
import HomeDeleteConfirmation from "../modals/HomeDeleteConfirmation";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { REQUEST_MASTER_MARKETING } from "../../store/marketing/marketingActionTypes";
import MarketingDeleteConfirmation from "../modals/MarketingDeleteConfirmation";

interface Props {
  query: string;
}

const MarketingMasterTable: React.FC<Props> = ({ query }) => {
  const dispatch = useDispatch();
  const { masterMarketing, busy } = useMarketingMaster();
  const searchColumns = useMemo(() => ["product_name"], []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [targetData, setTargetData] = useState<any>();

  console.log(masterMarketing, "mastermarketing");

  const updateEvent = (eventMaster: any) => {
    setTargetData(eventMaster);
    onOpen();
  };

  console.log("targetdataaaaa", targetData);

  const SingleImage = ({ image }: { image: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <img
        src={image}
        alt="Banner"
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "cover",
          borderRadius: "50%",
        }}
      />
    </div>
  );

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const deletes = (value: any) => {
    setTargetData(value);
    onDeleteOpen();
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const data = masterMarketing.map((item: any, index: any) => ({
    key: item._id,
    banner: `${process.env.REACT_APP_IMAGE_BASE_URL}/${item.imageId.url}`,
    status: item.status,
    bannerImgId: item.imageId._id,
  }));

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Banner Image",
      dataIndex: "banner",
      width: 100,
      render: (image: string) => <SingleImage image={image} />,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 130,
      render: (status: any) => {
        let bgColor = "";
        let textColor = "";
        switch (status.toLowerCase()) {
          case "publish":
            bgColor = "rgba(2, 164, 50, 0.10)";
            textColor = "#02A432";
            break;
          case "unpublish":
            bgColor = "rgba(212, 47, 47, 0.10)";
            textColor = "#D42F2F";
            break;
          default:
            bgColor = "transparent";
            textColor = "inherit";
        }
        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            {/* {status} */}
            {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
          </span>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      width: 100,
      render: (value: any) => (
        <Space size="middle">
          <RiEditLine
            onClick={() => {
              updateEvent(value);
            }}
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
          />
          <RiDeleteBin6Line
            onClick={() => {
              deletes(value);
            }}
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            {/* <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e) => setSearch(e.target.value)}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none", // Add this line to remove the blue outline
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none", // Add this line to ensure outline is removed in all browsers
                }}
              />
            </Box> */}
            <Spacer />

            <Box
              background="#E24441"
              fontSize={"sm"}
              color="#fff"
              w="fit-content"
              textAlign="center"
              p={3}
              onClick={() => {
                onOpen();
                setTargetData("");
              }}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441" }}
            >
              + Add marketing banner
            </Box>
          </Flex>

          <Spacer></Spacer>

          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={columns}
            dataSource={data}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            rowClassName={(record: any) => record.color}
            loading={busy && data.length === 0 ? true : false}
          />
        </div>
      </div>

      {isOpen && (
        <MarketingMasterEditDrawer
          isOpen
          onClose={onClose}
          event={targetData}
        />
      )}

      {isDeleteOpen && targetData && (
        <MarketingDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          event={targetData}
        />
      )}
    </>
  );
};

export default MarketingMasterTable;
